// Utility helpers for weekly menus
export const DAYS = [
  { key: "monday", label: "Segunda-feira", short: "Seg" },
  { key: "tuesday", label: "Terça-feira", short: "Ter" },
  { key: "wednesday", label: "Quarta-feira", short: "Qua" },
  { key: "thursday", label: "Quinta-feira", short: "Qui" },
  { key: "friday", label: "Sexta-feira", short: "Sex" },
  { key: "saturday", label: "Sábado", short: "Sáb" },
  { key: "sunday", label: "Domingo", short: "Dom" },
];

export const PROTEIN_CATEGORIES = [
  { value: "bovina", label: "Bovina" },
  { value: "frango", label: "Frango" },
  { value: "suina", label: "Suína" },
  { value: "peixe", label: "Peixe" },
  { value: "ovo", label: "Ovo" },
  { value: "outros", label: "Outros" },
];

// Get Monday (ISO) of the current week for a given date
export function getMondayISO(date = new Date()) {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun..6=Sat
  const diff = (day === 0 ? -6 : 1 - day);
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 10);
}

export function shiftWeek(iso, weeks) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + weeks * 7);
  return d.toISOString().slice(0, 10);
}

export function formatWeekRange(iso) {
  const start = new Date(iso + "T00:00:00");
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const fmt = (d) => d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  return `${fmt(start)} – ${fmt(end)}`;
}

export function formatKg(v) {
  return (Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
}

export function formatInt(v) {
  return (Number(v) || 0).toLocaleString("pt-BR");
}
